import { cn } from "@/lib/cn";

/**
 * ZonaClara mark for the public homepage.
 *
 * The ring is the place being watched. The three strokes are the ways the
 * alarm leaves that place: a message, an email, and a call. The dot is the
 * moment something crosses the limit.
 */
export function MarketingMark({ className }: { className?: string }) {
  return (
    <svg
      className={cn("marketing-mark", className)}
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="15.5" cy="20" r="8.5" stroke="currentColor" strokeWidth="2.25" />
      <circle cx="15.5" cy="20" r="2.8" fill="currentColor" />
      <path d="M23.2 14.4 27.2 10.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M24.4 20H29.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M23.2 25.6 27.2 29.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle className="marketing-mark-alert" cx="30.6" cy="8.4" r="2.7" />
    </svg>
  );
}
